// extracted by mini-css-extract-plugin
export default {"navLink":"NavLink_navLink__pp9M3","active":"NavLink_active__tlzRj","hidden":"NavLink_hidden__tJQjH","disabled":"NavLink_disabled__G4SEZ","onlyIcon":"NavLink_onlyIcon__xgXDT"};